import {
	Component,
	Inject,
	InjectionToken,
	Input,
	OnInit,
	SimpleChanges,
} from '@angular/core';

import Swal from 'sweetalert2';
import { User } from '../../../core/models/user';
import { AUTH_MODULES } from '../../timezones';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
	selector: 'app-auth-modules',
	templateUrl: './auth-modules.component.html',
	styleUrls: ['./auth-modules.component.scss'],
})
export class AuthModulesComponent implements OnInit {
	@Input() selectedUser: number;
	@Input() isClient: number;
	public user: User;

	public modules: any[];
	selUs: number;
	isCl: number;

	constructor(
		public authenticationService: AuthenticationService,
		public utils: UtilsService,
		public userService: UserService,
	) {}

	ngOnInit() {
		this.user = this.authenticationService.currentUserValue;
	}

	ngOnChanges(changes: SimpleChanges) {
		this.selUs = this.selectedUser;
		this.isCl = this.isClient;

		this.getUserModules();
	}

	getUserModules() {
		this.userService.getUserModules(this.selUs).subscribe((data: any) => {
			this.modules = [];
			data.body.map(
				(module: { link: string | string[]; type: string }) => {
					if (module.link.includes('admin/')) {
						module.type = 'Admin';
						this.modules.push(module);
					} else if (module.link.includes('caller/')) {
						module.type = 'Caller';
						if (this.isCl != 1) {
							this.modules.push(module);
						}
					} else if (module.link.includes('customer/')) {
						module.type = 'Customer';
						this.modules.push(module);
					}
				},
			);
		});
	}

	public setModulesToUser(module: any, is_active: any) {

		module.is_active = is_active;
		module.changed_by = this.user.login;
		module.last_change = this.utils.nowPHP();

		const payload = { module: module };
		this.userService.setModulesToUser(payload).subscribe((data: any)=>{
			let text = 'Deactivated';
			if (data.body.includes('1')) {
				text = 'Activated';
			}
			Swal.fire({
				title: 'Succesful',
				text: text,
				showCancelButton: false,
				confirmButtonText: 'Ok',
			});
			this.getUserModules();
		})
	}
}
